import actions from './actions';
import {setSupportedLocales as setSupportedLocalesShared} from './actionCreatorsShared';
import getSupportedLocales from './helpers/getSupportedLocales';

const supportedLocalesArray = getSupportedLocales();

const loadInitialLocale = (widgetPath, locale, localeModule) => ({
  type: actions.LOAD_INITIAL,
  payload: {widgetPath, locale, localeModule}
});

const setSupportedLocales = () =>
  setSupportedLocalesShared(supportedLocalesArray);

export {loadInitialLocale, setSupportedLocales};
